import { Injectable } from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { matches } from '@sama/micro-dash';
import { getInputUrls } from '../../../cross-team-shared/misc-utils';
import { AbstractSensorContentStore2D } from '../../shared/state/abstract-sensor-content-store-2d';
import { ImageContentState } from './image-content-state';

@Injectable()
export class ImageContentStore extends AbstractSensorContentStore2D<ImageContentState> {
  constructor(initialState: ImageContentState) {
    super(initialState, 'ImageContentStore');
  }

  getRawMask() {
    const rawMask = this.state().rawMask;
    assert(rawMask, 'We expect raw mask for raster!');
    return rawMask;
  }

  getHoveredColor() {
    const [pointX, pointY] = this.state().mouse.imagePoint;
    const width = this.state().sensorRendererState.width;

    if (pointX > width || pointX < 0) {
      return undefined;
    }

    const code = this.getRawMask()[pointX + pointY * width];
    if (!isDefined(code)) {
      return undefined;
    }
    return this.state().tagOptions.find((tagOption) => tagOption.code === code);
  }

  getAltInputUrl(): string | undefined {
    const { project, output, task, taskExtras } = this.state();
    const input = project.inputs.find(matches({ id: output.meta.input_id }))!;
    return getInputUrls(task, `alt_${input.name}`, taskExtras?.signed_urls)[0];
  }
}

export function isRawMaskBlank(rawMask: Uint8Array) {
  return rawMask.every((code) => code === 0);
}
